module.exports = __webpack_public_path__ + "static/media/creditcard.320a4dc8.svg";